<template>
  <div class="bottom">
    <div class="flex-grid">
      <div v-if="cityList" class="col-70 col-4 small">
        <ul>
          <p class="text-bold"> Provincies </p>
          <div
            v-for="(provincie, i) in provincieList()"
            :key="i"
          >
            <router-link 
              :to="{ name: 'Woningen te koop in provincy', params: { provincy: provincie.provincie } }"
            > 
              {{ provincie.provincie }} 
            </router-link>
          </div>
        </ul>
      </div>
      <div v-else>
        <Spinner />
      </div>

      <div v-if="cityList" class="col-70 col-4 small">
        <ul>
          <p class="text-bold"> Plaatsen </p>
          <div
            v-for="(city, i) in cityList"
            :key="i"
          >
            <router-link 
              v-show="i < 12" 
              :to="{ name: 'Woningen te koop in stad', params: { stad: city.stad, beschrijving: city.stadBeschrijving } }"
            > 
              {{city.stad}} 
            </router-link>
          </div>
          <router-link 
            :to="{ name: 'Woningen te koop in Nederland'}"
          > 
            <p> >> overige steden </p>
          </router-link>
        </ul>
      </div>

      <div class="col-70 col-4 small">
        <ul>
          <p class="text-bold"> Blog </p>
          <div
            v-for="(posts, i) in getPosts.stories"
            :key="i"
          >
            <li> <router-link :to="{name: 'BlogPagina', params: { postTitle: posts.content.title }}"> {{ posts.content.linkTekst }} </router-link> </li>
          </div>
        </ul>
      </div>
      <div class="col-70 col-4 small">
        <ul>
          <p class="text-bold"> Contact </p>
          <a
            href="mailto:info@isalu.nl"
            class="btn btn-orange-outlined"
          >mailen</a>
          <li> <router-link :to="{name: 'Over ons'}"> Over ons </router-link> </li>
        </ul>
      </div>
      <div class="line"></div>
      <div class="col-70 text-center small">
        <a> <router-link :to="{name: 'Over ons'}"> © 2024 iSalu </router-link> </a>
      </div>
      <Share />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Share from "@/components/ComponentShare";
import Spinner from "@/components/Spinner";
import axios from 'axios';

export default {
  name: "Footer",
  components: {
    Share,
    Spinner
  },
  data () {
    return {
      loading: false,
      error: null,
      cityList: null,
      starter: "",
    }
  },
  computed: {
    ...mapGetters(["getProperties", "getPosts", "getCoach"]),
  },
  mounted() {
    this.waitForLCP();
  },
  methods: {
    provincieList() {
      return this.cityList.filter((value, index, self) => 
        index === self.findIndex((t) => (
          t.provincie === value.provincie
        ))
      );
    },
    truncatedDescription(str) {
      return str.substring(0, 80) + "  ....";
    },
    openModal(straat) {
      this.starter = straat;
      this.$store.dispatch("toggleModal", !this.stateModal);
    },
    waitForLCP() {
      // Controleer eerst of PerformanceObserver beschikbaar is in de browser
      if ('PerformanceObserver' in window && 'largestContentfulPaint' in window.PerformanceObserver.supportedEntryTypes) {
        const observer = new PerformanceObserver((entryList) => {
          const entries = entryList.getEntries();
          // LCP bereikt, trigger Vue.js-code
          if (entries.length > 0 && entries[entries.length - 1].entryType === 'largestContentfulPaint') {
            this.executeAfterLCP();
            observer.disconnect();  // Stop met het observeren zodra LCP is bereikt
          }
        });

        // Begin met het observeren van de LCP-gebeurtenis
        observer.observe({ type: 'largest-contentful-paint', buffered: true });
      } else {
        // Als PerformanceObserver niet beschikbaar is, voer dan de code onmiddellijk uit
        this.fetchData();
      }
    },
    async fetchData() {
      this.loading = true; // Zet de loading status aan
      this.error = null;   // Reset eventuele eerdere fouten

      axios.defaults.headers.common['x-api-key'] = process.env.VUE_APP_GATEWAY_API;
      axios.defaults.responseType = 'json';

      const params = {
      };
      
      try {
        // Maak de API-aanroep
        const response = await axios.get('https://0ovja4ep62.execute-api.eu-west-2.amazonaws.com/' + process.env.NODE_ENV + '/getCitiesByProvincyName', { params});
        
        // Sla de opgehaalde data op in de component state
        this.cityList = response.data['body-json'].body;
        
      } catch (err) {
        // In geval van een fout, sla de fout op
        this.error = 'Er is een fout opgetreden bij het ophalen van de data.';
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style scoped>
.bottom {
  background-color: rgba(0,0,0,0.05);
  padding: 46px 46px 32px 46px;
}
.margin {
  margin-left: 4%;
  margin-right: 4%;
}
.line{
  border: 0.5px inset #000;
  width: 100%;
  margin: auto;
  margin-top: 2%;
  margin-bottom: 1%;
}
.line {
  font-size: 12px;
}
ul {
  padding: 0 20px;
}
ul img{
  height: 30px;
}
li {
  margin-top: 10px;
}
li :first-child{
  margin-top: 200px; 
}
.btn-blue-outlined,
.btn-orange-outlined {
  padding: 7px 12px;
  margin-bottom: 15px;
}

@media (max-width: 720px) and (min-width: 240px) {
  ul {
    padding: unset;
  }
  .bottom {
    padding: 23px 23px 16px 23px;
  }
}

</style>